const testArr = ["Hello", "World"];

export default testArr;